import React from 'react';
import PropTypes from 'prop-types';
import FlowGraphView from './Graph/FlowGraphView';
import FlowPropTypes from './PropTypes';
import FlowDebuggerView from '../view/Debugger/FlowDebuggerView';

class FlowGraphPanel extends React.Component {
	render() {
		const { flow, startDebug, clearDebug, debug, canDebug,
			flowId, projectName, ...rest } = this.props;
		return (
			<div className="flow-graph-panel">
				<FlowDebuggerView
					flowId={flowId}
					projectName={projectName}
					flow={flow.flow}
					canDebug={canDebug}
					startDebug={startDebug}
					clearDebug={clearDebug}
					error={debug.errorDetail}
					loading={debug.loading}
					response={debug.response}
				/>
				<FlowGraphView
					id="flow"
					flow={flow}
					{...rest}
				/>
			</div>
		);
	}
}

FlowGraphPanel.propTypes = {
	/**
	 * The node handlers
	 */
	nodehandlers: PropTypes.object.isRequired,
	/**
	 * The flow-trigger bindings to the flow.
	 */
	flowTriggers: FlowPropTypes.flowTriggers,
	/**
	 * The flow-trigger plugin definitions.
	 */
	triggerDefinitions: FlowPropTypes.triggerDefinitions,
	/**
	 * The flow to render
	 */
	flow: PropTypes.object.isRequired,
	/**
	 * Callback when a node is selected. Callback is passed the id of the node clicked.
	 */
	onNodeSelect: PropTypes.func.isRequired,
	/**
	 * Callback when a node is marked for deletion.
	 */
	onNodeDelete: PropTypes.func.isRequired,
	/**
	 * Callback when a node is insert.
	 */
	onNodeInsert: PropTypes.func.isRequired,
	/**
	 * Callback when a node is done inserting.
	 */
	onNodeInserted: PropTypes.func.isRequired,
	/**
	 * Callback when an edge is selected.
	 */
	onEdgeSelect: PropTypes.func.isRequired,
	/**
	 * Callback when an edge is marked for deletion.
	 */
	onEdgeDelete: PropTypes.func.isRequired,
	/**
	 * The selected node.
	 */
	selectedNode: FlowPropTypes.selectedNode,
	/**
	 * A flow validation status object.
	 */
	validationMap: PropTypes.shape({
		valid: PropTypes.bool,
		nodeErrors: PropTypes.object
	}),
	/*
	 * The selected edge.
	 */
	selectedEdge: PropTypes.object
};

export default FlowGraphPanel;
